// extracted by mini-css-extract-plugin
module.exports = {"home":"Home-module--home--59UN-","header":"Home-module--header--OHo8V","main":"Home-module--main--1SyTf","footer":"Home-module--footer--3toBj"};